<template>
  <div ref="app" data-app>
    <!-- <TestModuleComponent
      v-if="currentModule === 'TestModule'"
      ref="TestModule"
    /> -->

    <ExpenseSheetsModuleComponent
      v-if="currentModule === 'ExpenseSheetsModule'"
      ref="ExpenseSheetsModule"
    />

    <ExpenseSheetDetailDialogComponent
      v-if="currentModule === 'ExpenseSheetDetailDialog'"
      ref="ExpenseSheetDetailDialog"
    />

    <ProjectsModuleComponent
      v-if="currentModule === 'ProjectsModule'"
      ref="ProjectsModule"
    />

    <TrainingModuleComponent
      v-if="currentModule === 'TrainingModule'"
      ref="TrainingModule"
    />

    <TargetHoursModuleComponent
      v-if="currentModule === 'TargetHoursModule'"
      ref="TargetHoursModule"
    />

    <ActivityDetailModuleComponent
      v-if="currentModule === 'ActivityDetailModule'"
      ref="ActivityDetailModule"
    />

    <NewsModuleComponent
      v-if="currentModule === 'NewsModule'"
      ref="NewsModule"
    />

    <VacationsModuleComponent
      v-if="currentModule === 'VacationsModule'"
      ref="VacationsModule"
    />

    <VacationsDetailModuleComponent
      v-if="currentModule === 'VacationsDetailModule'"
      ref="VacationsDetailModule"
    />

    <SurveyViewerModuleComponent
      v-if="currentModule === 'SurveyViewerModule'"
      ref="SurveyViewerModule"
    />

    <ProfileModuleComponent
      v-if="currentModule === 'ProfileModule'"
      ref="ProfileModule"
    />

    <EmployeeCalendarComponent
      v-if="currentModule === 'EmployeeCalendar'"
      ref="EmployeeCalendar"
    />

    <DocumentsModuleComponent
      v-if="currentModule === 'DocumentsModule'"
      ref="DocumentsModule"
    />

    <DocByCategoryModuleComponent
      v-if="currentModule === 'DocByCategoryModule'"
      ref="DocByCategoryModule"
    />

    <ProceduresModuleComponent
      v-if="currentModule === 'ProceduresModule'"
      ref="ProceduresModule"
    />

    <!-- <DialogManagerComponent ref="DialogManager" @refresh="refreshModule" /> -->
  </div>
</template>
<script setup lang="ts">
import moment from "moment";
import { nextTick, onMounted, onUnmounted, ref, type ComponentPublicInstance } from "vue";
import { useI18n } from "vue-i18n";
import { gwtApi } from "./api/gwt/gwtAPI";
import type { SessionInformation } from "./api/gwt/gwtDTO";
import { useWebSocket } from "./composables/useWebSocket";
import { usePrimeVueLocale } from "./composables/usePrimeVueLocale";
// import TestModuleComponent from "./components/modules/TestModule.vue";
import ProjectsModuleComponent from "./components/modules/projects/ProjectsModule.vue";
import TrainingModuleComponent from "./components/modules/training/TrainingModule.vue";
import TargetHoursModuleComponent from "./components/modules/targethours/TargetHoursModule.vue";
import ActivityDetailModuleComponent from "./components/modules/activitydetail/ActivityDetailModule.vue";
import NewsModuleComponent from "./components/modules/news/NewsModule.vue";
import ProfileModuleComponent from "./components/modules/profile/ProfileModule.vue";
import SurveyViewerModuleComponent from "./components/modules/survey/SurveyViewerModule.vue";
import VacationsModuleComponent from "./components/modules/vacations/VacationsModule.vue";
import VacationsDetailModuleComponent from "./components/modules/vacations/VacationsDetailModule.vue";
import ExpenseSheetsModuleComponent from "./components/modules/expensesheets/ExpenseSheetsModule.vue";
import ExpenseSheetDetailDialogComponent from "./components/modules/expensesheets/ExpenseSheetDetailDialog.vue";
import EmployeeCalendarComponent from "./components/modules/employeecalendar/EmployeeCalendar.vue";
import DocumentsModuleComponent from "./components/modules/documents/DocumentsModule.vue";
import DocByCategoryModuleComponent from "./components/modules/documents/DocByCategoryModule.vue";
import ProceduresModuleComponent from "./components/modules/procedures/ProceduresModule.vue";
// import DialogManagerComponent from './components/modules/DialogManager.vue'

const { locale } = useI18n();
const { connect, disconnect } = useWebSocket();

// Sincronizar locale de PrimeVue con i18n
usePrimeVueLocale();

const currentModule = ref<string>("TestModule");
const app = ref<HTMLElement | null>(null);

const TestModule = ref<ComponentPublicInstance | null>(null);
const ProjectsModule = ref<ComponentPublicInstance | null>(null);
const TrainingModule = ref<ComponentPublicInstance | null>(null);
const TargetHoursModule = ref<ComponentPublicInstance | null>(null);
const ActivityDetailModule = ref<ComponentPublicInstance | null>(null);
const NewsModule = ref<ComponentPublicInstance | null>(null);
const ProfileModule = ref<ComponentPublicInstance | null>(null);
const SurveyViewerModule = ref<ComponentPublicInstance | null>(null);
const VacationsModule = ref<ComponentPublicInstance | null>(null);
const VacationsDetailModule = ref<ComponentPublicInstance | null>(null);
const ExpenseSheetsModule = ref<ComponentPublicInstance | null>(null);
const ExpenseSheetDetailDialog = ref<ComponentPublicInstance | null>(null);
const EmployeeCalendar = ref<ComponentPublicInstance | null>(null);
const DocumentsModule = ref<ComponentPublicInstance | null>(null);
const DocByCategoryModule = ref<ComponentPublicInstance | null>(null);
const ProceduresModule = ref<ComponentPublicInstance | null>(null);
// const DialogManager = ref<ComponentPublicInstance | null>(null);

// Mapa de referencias de módulos por nombre
const moduleRefs = {
  TestModule,
  ProjectsModule,
  TrainingModule,
  TargetHoursModule,
  ActivityDetailModule,
  NewsModule,
  ProfileModule,
  SurveyViewerModule,
  VacationsModule,
  VacationsDetailModule,
  ExpenseSheetsModule,
  ExpenseSheetDetailDialog,
  EmployeeCalendar,
  DocumentsModule,
  DocByCategoryModule,
  ProceduresModule,
  // DialogManager,
};

let gwtBridgeWaitTimer: number | null = null;
let themeWaitTimer: number | null = null;

const DEFAULT_PRIMARY_COLOR = "#185EA9";
const DEFAULT_PRIMARY_DARK_COLOR = "#0056b3";
const DEFAULT_SECONDARY_COLOR = "#6c757d";
const DEFAULT_PRIMARY_RGB = "24, 94, 169";

function resolveSocketUsername(): string | null {
  const sessionInformation = gwtApi.getSessionInformation();
  return sessionInformation?.employee?.username || null;
}

function normalizeColor(color?: string | null): string | null {
  if (!color) {
    return null;
  }

  const normalized = color.trim();
  return normalized.length > 0 ? normalized : null;
}

function colorToRgbTriplet(color?: string | null): string | null {
  const normalized = normalizeColor(color);
  if (!normalized) {
    return null;
  }

  const hex = normalized.replace("#", "");
  if (/^[0-9a-fA-F]{3}$/.test(hex)) {
    const expanded = hex
      .split("")
      .map((char) => `${char}${char}`)
      .join("");
    const red = Number.parseInt(expanded.substring(0, 2), 16);
    const green = Number.parseInt(expanded.substring(2, 4), 16);
    const blue = Number.parseInt(expanded.substring(4, 6), 16);
    return `${red}, ${green}, ${blue}`;
  }

  if (/^[0-9a-fA-F]{6}$/.test(hex)) {
    const red = Number.parseInt(hex.substring(0, 2), 16);
    const green = Number.parseInt(hex.substring(2, 4), 16);
    const blue = Number.parseInt(hex.substring(4, 6), 16);
    return `${red}, ${green}, ${blue}`;
  }

  const rgbMatch = normalized.match(
    /^rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/i
  );
  if (rgbMatch) {
    return `${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}`;
  }

  return null;
}

function darkenColor(color: string, factor = 0.15): string {
  const rgb = colorToRgbTriplet(color);
  if (!rgb) {
    return DEFAULT_PRIMARY_DARK_COLOR;
  }

  const [red, green, blue] = rgb.split(",").map((value) => Number.parseInt(value.trim(), 10));
  const darken = (channel: number) =>
    Math.max(0, Math.min(255, Math.round(channel * (1 - factor))));

  return `rgb(${darken(red)}, ${darken(green)}, ${darken(blue)})`;
}

function applyThemeVariables(sessionInformation: SessionInformation | null): void {
  const company = sessionInformation?.company;
  const primaryColor =
    company?.themeEnabled && normalizeColor(company.themePrimaryColor)
      ? normalizeColor(company.themePrimaryColor)!
      : DEFAULT_PRIMARY_COLOR;
  const secondaryColor =
    company?.themeEnabled && normalizeColor(company.themeSecondaryColor)
      ? normalizeColor(company.themeSecondaryColor)!
      : DEFAULT_SECONDARY_COLOR;
  const primaryRgb = colorToRgbTriplet(primaryColor) || DEFAULT_PRIMARY_RGB;
  const primaryDarkColor = darkenColor(primaryColor);

  const targets = [
    document.documentElement,
    window.$vueWrapper,
    window.$vueWrapperParent,
    app.value,
  ].filter(Boolean) as HTMLElement[];

  targets.forEach((target) => {
    target.style.setProperty("--primary-color", primaryColor);
    target.style.setProperty("--primary-rgb", primaryRgb);
    target.style.setProperty("--primary-dark-color", primaryDarkColor);
    target.style.setProperty("--secondary-color", secondaryColor);
  });
}

function syncThemeWhenReady(attempt = 0): void {
  const sessionInformation = gwtApi.getSessionInformation();
  if (sessionInformation?.company) {
    applyThemeVariables(sessionInformation);
    return;
  }

  if (attempt >= 100) {
    applyThemeVariables(null);
    console.warn("GWT bridge was not ready in time for theme initialization");
    return;
  }

  themeWaitTimer = window.setTimeout(() => {
    syncThemeWhenReady(attempt + 1);
  }, 100);
}

function connectWebSocketWhenReady(attempt = 0): void {
  const username = resolveSocketUsername();

  if (username) {
    connect(username);
    return;
  }

  if (attempt >= 100) {
    console.warn("GWT bridge was not ready in time for websocket initialization");
    return;
  }

  gwtBridgeWaitTimer = window.setTimeout(() => {
    connectWebSocketWhenReady(attempt + 1);
  }, 100);
}

function applyLocale(newLocale: string): void {
  locale.value = newLocale;
  moment.locale(newLocale);
  // console.log(`🌐 Idioma cambiado a ${newLocale}`);
}

function getCurrentModule(): string {
  return currentModule.value;
}

function refreshModule(): void {
  const moduleName = currentModule.value;
  const moduleRef = (moduleRefs as any)[moduleName]?.value;

  if (moduleRef && typeof moduleRef.refreshModule === "function") {
    moduleRef.refreshModule();
    // console.log(`🔄 Módulo ${moduleName} refrescado`);
  } else {
    console.warn(`⚠️ El módulo ${moduleName} no tiene método refreshModule()`);
  }
}

function showModule(module: string, payload?: any): void {
  currentModule.value = module;
  syncThemeWhenReady();

  nextTick(() => {
    nextTick(() => {
      const moduleRef = (moduleRefs as any)[module]?.value;

      if (moduleRef && typeof moduleRef.onReveal === "function") {
        moduleRef.onReveal(payload);
      }

      // Mostrar el wrapper de Vue si estaba oculto
      if (window.$vueWrapper) {
        window.$vueWrapper.style.display = "block";
      }
    });
  });
}

onMounted(() => {
  // Exponer VueBridge INMEDIATAMENTE (antes de nextTick)
  window.$vueBridge = {
    applyLocale,
    getCurrentModule,
    refreshModule,
    showModule,
  };

  // console.log("✅ App.vue montado, VueBridge expuesto a GWT");
  // console.log("🔍 window.$vueBridge disponible:", typeof window.$vueBridge);
  // console.log("🔍 Métodos disponibles:", Object.keys(window.$vueBridge));

  nextTick(() => {
    // Ajustar altura mínima del contenedor
    if (app.value) {
      const firstChild = app.value.firstElementChild as HTMLElement;
      if (firstChild) {
        firstChild.style.minHeight = "100%";
      }
    }
  });

  syncThemeWhenReady();
  connectWebSocketWhenReady();
});

onUnmounted(() => {
  if (gwtBridgeWaitTimer !== null) {
    window.clearTimeout(gwtBridgeWaitTimer);
  }
  if (themeWaitTimer !== null) {
    window.clearTimeout(themeWaitTimer);
  }
  disconnect();
});
</script>

<style>
/* Estilos globales para la aplicación */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

/* Asegurar que el contenedor raíz de Vue ocupe todo el espacio */
[data-app] {
  position: relative;
  width: 100% !important;
  min-height: 100% !important;
  height: 100% !important;
  display: block;
}

/* Asegurar que los módulos hijos también ocupen 100% */
[data-app] > * {
  width: 100%;
  min-height: 100%;
}

/* Ocultar selector de empresas en el detalle de hoja de gastos */
body.hide-expense-sheet-profiles #mainProfilesPanel {
  display: none !important;
}
</style>
